import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { FcmPush } from '@/services/fcm-push.plugin';

const TAG_PREFIX = 'messenger-';

function asRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return undefined;
  return value as Record<string, unknown>;
}

function pickChatIdFromData(data: Record<string, unknown> | undefined): number | null {
  if (!data) return null;
  const flat = { ...data, ...(asRecord(data.data) || {}) };
  const raw = flat.chatId ?? flat.chat_id;
  const chatId = Number(raw);
  if (Number.isFinite(chatId) && chatId !== 0) return chatId;
  return null;
}

function matchesChatTag(tag: string | undefined, chatId: number): boolean {
  if (!tag) return false;
  return tag === `${TAG_PREFIX}${chatId}` || tag === String(chatId);
}

/**
 * Снять доставленные пуши конкретного чата (тот же и другие устройства через WS/silent sync).
 * Не трогает уведомления других чатов.
 */
export async function clearDeliveredMessengerNotifications(chatId: number): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (!Number.isFinite(chatId) || chatId === 0) return;

  try {
    if (Capacitor.getPlatform() === 'ios') {
      try {
        await FcmPush.clearByChatId({ chatId });
        return;
      } catch {
        /* fallback to Capacitor list below */
      }
    }

    const { notifications } = await PushNotifications.getDeliveredNotifications();
    const match = (notifications || []).filter((n) => {
      const tag = (n as { tag?: string }).tag;
      if (matchesChatTag(tag, chatId)) return true;
      const data = (n.data || {}) as Record<string, unknown>;
      return pickChatIdFromData(data) === chatId;
    });
    if (match.length) {
      await PushNotifications.removeDeliveredNotifications({ notifications: match });
    }
  } catch (error) {
    console.warn('[push] clear messenger notifications failed', error);
  }
}

export function messengerNotificationTag(chatId: number): string {
  return `${TAG_PREFIX}${chatId}`;
}
